// Popula a seção
function populateSobre($parent, section, action = 'insert') {
  if ($parent.length > 0 && section) {
    // Atualiza a seção (Remove antes para ser criada novamente)
    if (action === 'update') {
      const $sectionUpd = $('#' + section.id);
      if ($sectionUpd.length > 0) {
        $sectionUpd.html('');
        $sectionUpd.remove();
      }
    }

    // Exibe seção
    const showSection = section['show'];
    const showSectionClass = !showSection ? 'd-none' : '';

    // Mídia (Imagem/Vídeo)
    let $media;
    if (section['media-type'] == 'image') {
      $media = `<figure class="img sobre-img ${section['img-format']}">
        <img src="${section['img-src']}" width="800px" height="600px" alt="${section['img-alt']}">
      </figure>`;
    } else if (section['media-type'] == 'video') {
      const videoThumb =
        section['img-thumb'] == '1' && section['img-src'] != ''
          ? section['img-src']
          : getVideoThumb(section['video_id'], section['video_plataforma']);
      $media = `<div class="embed video-load sobre-video ${section['img-format']}" data-video-id="${
        section['video_id']
      }" data-video-plataform="${section['video_plataforma']}">
        <div class="embed-item embed-item-video" style="background-image: url('${videoThumb}')">
          <span class="embed-item-video-play">${getSvgIcon('play')}</span>
        </div>
      </div>`;
    }

    // Subtítulo
    const subtitTopClass = section['subtit-top'] == '1' ? 'subtit-top' : '';
    const $subtitulo =
      section['subtitulo'] != ''
        ? `<h3 class="subtitle ${subtitTopClass}">${mdParse(section['subtitulo'], true)}</h3>`
        : '';

    // Botão
    let $botao;
    if (section['btn-show'] == '1') {
      $botao = `<div class="sobre-btn-wrp">
        <a href="${section['btn-url']}" class="btn ${section['btn-class']} ${
        confTheme['general'][section['btn-class'] + '-style']
      }">${section['btn-text']}</a>
      </div>`;
    }

    const mediaGrid = section['media-align'] != 'center' ? 'grid-6' : 'grid-7';
    const infosGrid = section['media-align'] != 'center' ? 'grid-6' : 'grid-7';

    // Estrutura da seção
    let sectionHTML = `
    <section id="${section['id']}" data-sec-type="sobre" class="home-section sobre bg-image ${showSectionClass}">
      <div class="section-content">
        <div class="container">
          <div class="row sobre-wrp ${section['media-align']}">
            <div class="${mediaGrid} grid-md-9 grid-sm-12 grid-xs-12 sobre-media">
              ${$media}
            </div>
            <div class="${infosGrid} grid-md-9 grid-sm-12 grid-xs-12 sobre-infos ${section['infos-align']}">
              <div class="sobre-tit-wrp">
                <h2 class="title">${section['titulo']}</h2>
                ${$subtitulo}
              </div>
              <div class="md-text sobre-texto">${mdParse(section['texto'])}</div>
              ${$botao}
            </div>
          </div>
        </div>
      </div>
    </section>`;

    // Cria o elemento
    let $section = $(sectionHTML);

    // Estilos
    if (Object.keys(section.styles).length > 0) {
      Object.keys(section.styles).forEach((styleVar) => {
        $section[0].style.setProperty('--' + styleVar, section.styles[styleVar]);
      });
    }

    // Ordem da seção
    $section[0].style.setProperty('--order', section['order']);
    $section[0].style.setProperty('order', section['order']);

    // Plano de fundo (Imagem)
    if (section['bg-type'] == 'image') {
      $section[0].style.setProperty('background-image', `url('${section['bg-image']}')`);
    }
    // Plano de fundo (Gradiente)
    else if (section['bg-type'] == 'gradient') {
      $section[0].style.setProperty('background-image', section['bg-gradient']);
    }

    $parent.append($section);
  }
}
